import { API } from "."
import type { DashboardConfig, DashboardConfigResponse, WidgetItem } from "@/types/dashboard"
import type { ApiResponse } from "./type"

/** 대시보드 템플릿 조회 — content(JSON string)를 파싱하여 반환 */
export async function readDashboard(): Promise<ApiResponse<DashboardConfig>> {
  const res = await API.get<DashboardConfigResponse>("/dashboard")
  const raw = res.response

  let widgets: WidgetItem[] = []
  try {
    widgets = raw?.content ? JSON.parse(raw.content) : []
  } catch {
    widgets = []
  }

  return {
    success: res.success,
    error: res.error,
    response: {
      widgets,
      dateUpdated: raw?.dateUpdated ?? null,
    },
  }
}

/** 대시보드 템플릿 저장 (upsert) — widgets 배열을 JSON string으로 변환하여 전송 */
export async function updateDashboard(widgets: WidgetItem[]) {
  return await API.put<DashboardConfigResponse>("/dashboard", {
    content: JSON.stringify(widgets),
  })
}
